/**
 * MAKE ONLY SUBMENU ITEMS CLICKABLE
 * Main "Shop" stays hover-only
 */
document.addEventListener('DOMContentLoaded', function() {
  // Make main Shop link hover-only (not clickable)
  const shopLink = document.querySelector('.header__menu-item a[href="/collections"]');
  if (shopLink) {
    shopLink.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent Shop from being clickable
    });
    shopLink.style.cursor = 'default'; // Change cursor to show it's not clickable
  }
  
  // Make submenu parent items clickable
  const submenuParents = document.querySelectorAll('.header__submenu .header__menu-item--link');
  
  submenuParents.forEach(item => {
    const link = item.querySelector('a');
    if (link) {
      // These remain clickable - they're the submenu items
      link.style.cursor = 'pointer';
    }
  });
  
  // Update your URL mapping for the actual submenu items
  function getCollectionUrl(text) {
    const urlMap = {
      'Halters & Lead Ropes': '/collections/halters-lead-ropes',
      'Rope Tack': '/collections/rope-tack', 
      'Dog Accessories': '/collections/dog-accessories',
      'Clips & Accessories': '/collections/clips-accessories',
      'All Products': '/collections/all'
    };
    
    return urlMap[text] || '/collections/all';
  }
});